module.exports = __webpack_public_path__ + "static/media/ljusdosan2.02320a4f.png";